var GroupCriteriaType = /* @__PURE__ */ ((GroupCriteriaType2) => {
  GroupCriteriaType2["Deposit"] = "deposit";
  GroupCriteriaType2["Blacklist"] = "blacklist";
  return GroupCriteriaType2;
})(GroupCriteriaType || {});
var GroupSystemListKey = /* @__PURE__ */ ((GroupSystemListKey2) => {
  GroupSystemListKey2["Blacklist"] = "default-blacklist";
  return GroupSystemListKey2;
})(GroupSystemListKey || {});
var GroupStatus = /* @__PURE__ */ ((GroupStatus2) => {
  GroupStatus2["Active"] = "active";
  GroupStatus2["Inactive"] = "inactive";
  return GroupStatus2;
})(GroupStatus || {});
var GroupType = /* @__PURE__ */ ((GroupType2) => {
  GroupType2["Auto"] = "auto";
  GroupType2["Manual"] = "manual";
  return GroupType2;
})(GroupType || {});
var MemberStatus = /* @__PURE__ */ ((MemberStatus2) => {
  MemberStatus2["Active"] = "active";
  MemberStatus2["Suspended"] = "suspended";
  MemberStatus2["Frozen"] = "frozen";
  MemberStatus2["Closed"] = "closed";
  return MemberStatus2;
})(MemberStatus || {});
var CredentialType = /* @__PURE__ */ ((CredentialType2) => {
  CredentialType2["CryptoSignature"] = "cryptoSignature";
  CredentialType2["Programmatic"] = "programmatic";
  CredentialType2["Password"] = "password";
  CredentialType2["Totp"] = "totp";
  return CredentialType2;
})(CredentialType || {});
var PrivilegeDomain = /* @__PURE__ */ ((PrivilegeDomain2) => {
  PrivilegeDomain2["Account"] = "account";
  PrivilegeDomain2["Platform"] = "platform";
  return PrivilegeDomain2;
})(PrivilegeDomain || {});
var WalletTxType = /* @__PURE__ */ ((WalletTxType2) => {
  WalletTxType2["Deposit"] = "deposit";
  WalletTxType2["Withdrawal"] = "withdrawal";
  WalletTxType2["Reversal"] = "reversal";
  WalletTxType2["AggregateBet"] = "aggregate-bet";
  WalletTxType2["Mint"] = "mint";
  WalletTxType2["AdjustBalance"] = "adjust-balance";
  WalletTxType2["DailyBonus"] = "daily-bonus";
  WalletTxType2["Transfer"] = "transfer";
  WalletTxType2["CashBack"] = "cash-back";
  WalletTxType2["Turnover"] = "turnover";
  WalletTxType2["CreditLoss"] = "credit-loss";
  return WalletTxType2;
})(WalletTxType || {});
var WalletTxMethod = /* @__PURE__ */ ((WalletTxMethod2) => {
  WalletTxMethod2["DailyBonus"] = "daily-bonus";
  WalletTxMethod2["InstantCashBack"] = "cash-back-instant";
  WalletTxMethod2["DailyCashBack"] = "cash-back-daily";
  WalletTxMethod2["WeeklyCashBack"] = "cash-back-weekly";
  WalletTxMethod2["MonthlyCashBack"] = "cash-back-monthly";
  WalletTxMethod2["ReferralCommission"] = "referral-commission";
  WalletTxMethod2["ExternalBonus"] = "external-bonus";
  WalletTxMethod2["SkinnerBox"] = "skinner-box";
  WalletTxMethod2["Compensation"] = "compensation";
  return WalletTxMethod2;
})(WalletTxMethod || {});
export {
  CredentialType,
  GroupCriteriaType,
  GroupStatus,
  GroupSystemListKey,
  GroupType,
  MemberStatus,
  PrivilegeDomain,
  WalletTxMethod,
  WalletTxType
};
